import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  inject,
} from '@angular/core';

import { NEVER, Observable } from 'rxjs';

import { CustomIcon, IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { NativeBridgeService } from '@fcom/core/services/native-bridge/native-bridge.service';

@Component({
  selector: 'fin-header-boxes',
  styleUrls: ['./header-boxes.component.scss'],
  templateUrl: './header-boxes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderBoxesComponent implements OnInit {
  private nativeBridgeService = inject(NativeBridgeService);
  private cdr = inject(ChangeDetectorRef);

  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;

  @Input()
  homeLink$: Observable<string> = NEVER;

  showLink: boolean;

  @Output()
  homeGtmEvent: EventEmitter<Event> = new EventEmitter<Event>();

  ngOnInit(): void {
    if (this.nativeBridgeService.isInsideNativeWebView) {
      this.showLink = false;
    } else {
      this.showLink = true;
    }
    this.cdr.markForCheck();
  }
}
